import React, { createContext, useContext, useState, useEffect } from 'react';
import { useAuth } from './AuthContext';
import * as api from '../api';

const FavoritesContext = createContext();

export const useFavorites = () => {
  const context = useContext(FavoritesContext);
  if (!context) {
    throw new Error('useFavorites must be used within a FavoritesProvider');
  }
  return context;
};

export const FavoritesProvider = ({ children }) => {
  const { user, setUser } = useAuth();
  const [favorites, setFavorites] = useState([]);

  // Sync favorites with user data
  useEffect(() => {
    if (user && user.favorites) {
      setFavorites(user.favorites);
    } else {
      setFavorites([]);
    }
  }, [user]);

  const toggleFavorite = async (productId) => {
    if (!user) {
      return false; // User must be logged in
    }
    
    try {
      const result = await api.toggleFavorite(user.id, productId);
      setFavorites(result.favorites);
      setUser(prev => ({ ...prev, favorites: result.favorites }));
      return true;
    } catch (error) {
      console.error('Failed to toggle favorite:', error);
      return false;
    }
  };

  const isFavorite = (productId) => {
    return favorites.includes(productId);
  };

  const getFavoritesCount = () => {
    return favorites.length;
  };

  return (
    <FavoritesContext.Provider value={{
      favorites,
      toggleFavorite,
      isFavorite,
      getFavoritesCount
    }}>
      {children}
    </FavoritesContext.Provider>
  );
};
